import { render } from "./BlockWrapper.vue?vue&type=template&id=756e924e&scoped=true"
import script from "./BlockWrapper.vue?vue&type=script&lang=js"
export * from "./BlockWrapper.vue?vue&type=script&lang=js"

import "./BlockWrapper.vue?vue&type=style&index=0&id=756e924e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-756e924e"]])

export default __exports__